import PropTypes from 'prop-types';

import { Filter } from '@common/components/Icons';

import {
  Container,
  Counter,
  FiltersButton,
  FloatingContainer,
  Inner,
} from './FiltersToggleButton.styled';

function FiltersToggleButton({
  onClick,
  filtersCount,
  isFiltered,
  shouldRenderExternally,
}) {
  return (
    <Container shouldRenderExternally={shouldRenderExternally}>
      <FloatingContainer>
        <Inner>
          <FiltersButton
            id="clothing_filter_open"
            onClick={onClick}
            icon={<Filter />}
            shouldRenderExternally={shouldRenderExternally}
          />
          {isFiltered && filtersCount > 0 && (
            <Counter>{filtersCount > 9 ? '9+' : filtersCount}</Counter>
          )}
        </Inner>
      </FloatingContainer>
    </Container>
  );
}

FiltersToggleButton.defaultProps = {
  filtersCount: 0,
  shouldRenderExternally: false,
};

FiltersToggleButton.propTypes = {
  filtersCount: PropTypes.number,
  onClick: PropTypes.func.isRequired,
  isFiltered: PropTypes.bool.isRequired,
  shouldRenderExternally: PropTypes.bool,
};

export { FiltersToggleButton };
